import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default function Scrollanimation() {
  Alpine.data("scrollAnimation", () => ({
    init() {
      const elements = document.querySelectorAll("[data-fade-in]");
      if (!elements.length) return;

      gsap.set(elements, { opacity: 0, y: 30 });

      ScrollTrigger.batch(elements, {
        onEnter: (batch) =>
          gsap.to(batch, {
            opacity: 1,
            y: 0,
            duration: 0.95,
            ease: "power3.out",
            stagger: 0.08,
          }),
        start: "top 88%",
      });
    },
  }));
}
